module.exports = __webpack_public_path__ + "img/djupdate.5e06cfa5.svg";